import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService  {
  loginUrl = `${environment.FRONTEND_HOMEPAGE_URL}/login`;

  constructor(private _auth: AuthService, private router: Router) {}
  canActivate(): boolean {
    if (this._auth.loggedIn()) {
      return true;
    }
    window.location.href = this.loginUrl;
  }
}
